import type { ExerciseSessionAnswers } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useExerciseSession, useCreate: useCreateQuizSession } = getCRUDHooks({
  entityName: 'exerciseSessions',
  get: ({ exerciseSessionId }) =>
    clientApi.getOCClient().helpers.assessment.exerciseSessions.get(exerciseSessionId),
  create: ({ userId, quizId }) =>
    clientApi
      .getOCClient()
      .helpers.assessment.exerciseSessions.create({ userId, exerciseId: Number(quizId) }),
});

const { useCreate: useSubmitExerciseSession } = getCRUDHooks({
  entityName: 'exerciseSessions',
  create: ({
    exerciseSessionId,
    exerciseSessionAnswers,
  }: {
    exerciseSessionId: number;
    exerciseSessionAnswers: ExerciseSessionAnswers;
  }) =>
    clientApi
      .getOCClient()
      .helpers.assessment.exerciseSessions.submit(exerciseSessionId, exerciseSessionAnswers),
});

export { useExerciseSession, useSubmitExerciseSession, useCreateQuizSession };
